<template>
  <!-- 业务表单 -->
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{ $t('label.SupplierInformation') }}</span>
        <Icon type="ios-create-outline" class="applyicon" />
        <!-- <Button type="primary" long  class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
        </Button>-->
      </div>
      <Form ref="formdata" :model="formdata" :rules="rules">
        <table class="form-table form-table-print">
          <!-- 基本信息 -->
          <tr>
            <th
              rowspan="10"
              style="width:13%;"
              v-if="formdata.specialFlg==='1' && formdata.isNda === '1'"
            >
              <span class>{{ $t('label.Supplier.BasicA') }}</span>
            </th>
            <th rowspan="9" style="width:13%;" v-else>
              <span class>{{ $t('label.Supplier.BasicA') }}</span>
            </th>
            <th style="word-break: break-all;width:13%; padding:0px !important;" rowspan="3">
              <div class="content_box">
                <div
                  class="contentleft requiredIitm"
                >{{$t('lable.InquiryInvitationApply.corporateName')}}</div>
                <div class="contentright">
                  <div>{{$t('label.Supplier.Basic.Chinese')}}</div>
                  <div>{{$t('label.Supplier.Basic.English')}}</div>
                  <div>{{$t('label.Supplier.Basic.Japanese')}}</div>
                </div>
              </div>
            </th>
            <td style="width:30%;" colspan="2">
              <template v-if="formdata.internalFlg==='0'">
                <Form-item prop="supplierNameCn">
                  <Input
                    @on-change="changeTextName"
                    :disabled="permission.supplierNameCn!=='w'"
                    type="text"
                    v-model="formdata.supplierNameCn"
                  />
                </Form-item>
              </template>
              <template v-else>
                <div style="padding:0px 5px;">
                  <Input
                    :disabled="permission.supplierNameCn!=='w'"
                    type="text"
                    v-model="formdata.supplierNameCn"
                  />
                </div>
              </template>
            </td>
            <th style="width:13%;">
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierCountry') }}</span>
            </th>
            <td style="width:30%;" colspan="2">
              <Form-item prop="internalFlg">
                <Select
                  @on-change="nameTextChange"
                  v-model="formdata.internalFlg"
                  style="width:100%;"
                  :disabled="permission.internalFlg!=='w'"
                >
                  <Option
                    v-for="item in [{value:'0',label:$t('label.Supplier.Basic.Abroad')},{value:'1',label:$t('label.Supplier.Basic.Home'),}]"
                    :value="item.value"
                    :key="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </Form-item>
            </td>
          </tr>
          <tr>
            <!-- 公司英文名 -->
            <td colspan="2">
              <template v-if="formdata.internalFlg==='1'">
                <Form-item prop="supplierNameEn">
                  <Input
                    @on-change="changeTextName"
                    :disabled="permission.supplierNameEn!=='w'"
                    type="text"
                    v-model="formdata.supplierNameEn"
                  />
                </Form-item>
              </template>
              <template v-else>
                <div style="padding:0px 5px;">
                  <Input
                    :disabled="permission.supplierNameEn!=='w'"
                    type="text"
                    v-model="formdata.supplierNameEn"
                  />
                </div>
              </template>
            </td>
            <th>
              <span
                :class="{'requiredIitm':formdata.internalFlg!=='1'}"
              >{{ $t('label.Supplier.Basic.SupplierAddress') }}</span>
            </th>
            <td colspan="2">
              <div style="display:flex;justify-content:space-between;">
                <template v-if="formdata.internalFlg==='1'">
                  <div class="cityitem" style="padding-left:5px;">
                    <!-- 请输入省 -->
                    <Input
                      disabled
                      type="text"
                      v-model="formdata.province"
                    />
                  </div>
                  <div class="cityitem" style="padding-left:5px;">
                    <!-- 请输入市 -->
                    <Input
                      disabled
                      type="text"
                      v-model="formdata.city"
                    />
                  </div>
                </template>
                <template v-else>
                  <!-- 请输入省 -->
                  <Form-item prop="province" class="cityitem">
                    <Input
                      :disabled="permission.city!=='w'"
                      type="text"
                      v-model="formdata.province"
                    />
                  </Form-item>
                  <!-- 请输入市 -->
                  <Form-item prop="city" class="cityitem">
                    <Input
                      :disabled="permission.city!=='w'"
                      type="text"
                      v-model="formdata.city"
                    />
                  </Form-item>
                </template>
              </div>
            </td>
          </tr>
          <tr>
            <!-- 公司日文名 -->
            <td colspan="2">
              <Form-item prop="supplierNameJp">
                <Input
                  :disabled="permission.supplierNameJp!=='w'"
                  type="text"
                  v-model="formdata.supplierNameJp"
                />
              </Form-item>
            </td>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierAddressDetail') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="address">
                <Input :disabled="permission.address!=='w'" type="text" v-model="formdata.address" />
              </Form-item>
            </td>
          </tr>

          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierLealperson') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="legalRepresentative">
                <Input
                  :disabled="permission.legalRepresentative!=='w'"
                  type="text"
                  v-model="formdata.legalRepresentative"
                />
              </Form-item>
            </td>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierRegisterMoney') }}</span>
            </th>
            <td colspan="2">
              <div style="display:flex;align-items:center;">
                <Form-item prop="registeredCapital" style="width:50%;">
                  <!-- 注册资金万元 -->
                  <InputNumber
                    style="width:100%;"
                    :disabled="permission.registeredCapital!=='w'"
                    :active-change="false"
                    :min="0"
                    :precision="2"
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/,/g, '')"
                    v-model="formdata.registeredCapital"
                  ></InputNumber>
                </Form-item>
                <span style="width:20%;">{{$t('lable.InquiryInvitationApply.currency')}}</span>
                <Form-item prop="currency" style="width:30%;">
                  <Select
                    v-model="formdata.currency"
                    style="width:100%;"
                    :disabled="permission.currency!=='w'"
                    class="select_h_140"
                  >
                    <Option v-for="item in currencyList" :value="item" :key="item">{{ item }}</Option>
                  </Select>
                </Form-item>
              </div>
            </td>
          </tr>
          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierEstablishDate') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="timeOfEstablishment">
                <ab-date
                  :disabled="permission.timeOfEstablishment!=='w'"
                  style="width:100%;"
                  v-model="formdata.timeOfEstablishment"
                  format="yyyy-MM-dd"
                ></ab-date>
              </Form-item>
            </td>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.BusinessLicense') }}</span>
            </th>
            <td colspan="2">
              <ab-upload
                v-model="formdata.businessLicense"
                abPermission="w"
                :disabled="permission.businessLicense!=='w'"
                :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
              ></ab-upload>
            </td>
          </tr>
          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SpecialBiz') }}</span>
            </th>
            <td colspan="5" style="text-align:left;">
              <Form-item prop="specialFlg">
                <div style="display:flex;">
                  <div>
                    <Select
                      @on-change="specialFlgChange"
                      v-model="formdata.specialFlg"
                      style="width:120px;"
                      :disabled="permission.specialFlg!=='w'"
                    >
                      <Option
                        v-for="item in [{value:'0', label: $t('label.Supplier.Basic.IsSpecialBiz')},{value:'1',label: $t('label.Supplier.Basic.NonSpecialBiz'),}]"
                        :value="item.value"
                        :key="item.value"
                      >{{ item.label }}</Option>
                    </Select>
                  </div>
                  <div class="tipscontent" style="margin-left:5px;">
                    <span class="circleicon">
                      <Icon type="ios-information-circle" />
                    </span>
                    <span>{{$t('label.Supplier.Basic.SpecialBizDetail')}}</span>
                  </div>
                </div>
              </Form-item>
              <!-- ※特殊企业：政府系企业/研究机构 国有企业 大学 丰田集团公司 丰田经销商 -->
            </td>
          </tr>
          <!-- 投资方部分 -->
          <tr v-if="formdata.specialFlg==='1' && formdata.isNda === '1'">
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierProperty') }}</span>
            </th>
            <td colspan="5" style="text-align:left;">
              <div class="typecontent">
                <Form-item prop="enterpriseProperties">
                  <Select
                    v-model="formdata.enterpriseProperties"
                    :disabled="permission.enterpriseProperties!=='w'"
                    style="width:120px;"
                  >
                    <Option
                      v-for="item in listProperties"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.label }}</Option>
                  </Select>
                </Form-item>
                <span style="margin:0px 5px;">{{ $t('label.Supplier.Basic.Top4Investors') }}</span>
                <ul>
                  <li>
                    <Form-item prop="investedPercenTxt1">
                      <Input
                        style="width:300px;"
                        :disabled="permission.investedPercenTxt1!=='w'"
                        type="text"
                        v-model="formdata.investedPercenTxt1"
                      />
                    </Form-item>
                    <span class="text">{{ $t('label.Supplier.Basic.ProportionOfInvestors') }}</span>
                    <Form-item prop="investedPercenVal1">
                      <InputNumber
                        :precision="2"
                        style="width:100px;"
                        :disabled="permission.investedPercenVal1!=='w'"
                        :active-change="false"
                        :min="0"
                        v-model="formdata.investedPercenVal1"
                      ></InputNumber>
                    </Form-item>
                    <span>%</span>
                  </li>
                  <li>
                    <Form-item prop="investedPercenTxt2">
                      <Input
                        style="width:300px;"
                        :disabled="permission.investedPercenTxt2!=='w'"
                        type="text"
                        v-model="formdata.investedPercenTxt2"
                      />
                    </Form-item>
                    <span class="text">{{ $t('label.Supplier.Basic.ProportionOfInvestors') }}</span>
                    <Form-item prop="investedPercenVal2">
                      <InputNumber
                        :precision="2"
                        style="width:100px;"
                        :disabled="permission.investedPercenVal2!=='w'"
                        :active-change="false"
                        :min="0"
                        v-model="formdata.investedPercenVal2"
                      ></InputNumber>
                    </Form-item>
                    <span>%</span>
                  </li>
                  <li>
                    <Form-item prop="investedPercenTxt3">
                      <Input
                        style="width:300px;"
                        :disabled="permission.investedPercenTxt3!=='w'"
                        type="text"
                        v-model="formdata.investedPercenTxt3"
                      />
                    </Form-item>
                    <span class="text">{{ $t('label.Supplier.Basic.ProportionOfInvestors') }}</span>
                    <Form-item prop="investedPercenVal3">
                      <InputNumber
                        :precision="2"
                        style="width:100px;"
                        :disabled="permission.investedPercenVal3!=='w'"
                        :active-change="false"
                        :min="0"
                        v-model="formdata.investedPercenVal3"
                      ></InputNumber>
                    </Form-item>
                    <span>%</span>
                  </li>
                  <li>
                    <Form-item prop="investedPercenTxt4">
                      <Input
                        style="width:300px;"
                        :disabled="permission.investedPercenTxt4!=='w'"
                        type="text"
                        v-model="formdata.investedPercenTxt4"
                      />
                    </Form-item>
                    <span class="text">{{ $t('label.Supplier.Basic.ProportionOfInvestors') }}</span>
                    <Form-item prop="investedPercenVal4">
                      <InputNumber
                        :precision="2"
                        style="width:100px;"
                        :disabled="permission.investedPercenVal4!=='w'"
                        :active-change="false"
                        :min="0"
                        v-model="formdata.investedPercenVal4"
                      ></InputNumber>
                    </Form-item>
                    <span>%</span>
                  </li>
                </ul>
              </div>
            </td>
          </tr>

          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.BizScope') }}</span>
            </th>
            <td colspan="5">
              <Form-item prop="businessLine">
                <Input
                  :disabled="permission.businessLine!=='w'"
                  type="textarea"
                  autosize
                  v-model="formdata.businessLine"
                />
              </Form-item>
            </td>
          </tr>
          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierContact') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="contact">
                <Input :disabled="permission.contact!=='w'" type="text" v-model="formdata.contact" />
              </Form-item>
            </td>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierPhone') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="telNo">
                <Input :disabled="permission.telNo!=='w'" type="text" v-model="formdata.telNo" />
              </Form-item>
            </td>
          </tr>

          <tr>
            <th>
              <span class="requiredIitm">{{ $t('label.Supplier.Basic.SupplierEmail') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="mailAddress">
                <Input
                  :disabled="permission.mailAddress!=='w'"
                  type="text"
                  v-model="formdata.mailAddress"
                />
              </Form-item>
            </td>
            <th>
              <span class>{{ $t('label.Supplier.Basic.SupplierFax') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="faxNo">
                <Input :disabled="permission.faxNo!=='w'" type="text" v-model="formdata.faxNo" />
              </Form-item>
            </td>
          </tr>

          <!-- 企业实力 -->
          <tr v-if="formdata.isNda =='1'">
            <!-- <th rowspan="2">{{ $t('label.Supplier.StrengthA') }}</span></th>
              <th><span class="requiredIitm">{{ $t('label.Supplier.Basic.BusinessLicense') }}</span></th>
              <td>

              <Upload
                style=""
                v-model="formdata.businessLicense"
                action="//jsonplaceholder.typicode.com/posts/"
              >
                <div>
                  <Icon type="ios-cloud-upload" style="color: #3399ff;font-size:30px"></Icon>
                </div>
              </Upload>

            </td>-->
            <th>
              <span class>{{ $t('label.Supplier.StrengthA') }}</span>
            </th>
            <th>
              <span class>{{ $t('label.Supplier.Strength.Qualifications') }}</span>
            </th>
            <td colspan="2">
              <ab-upload
                v-model="formdata.qualifications"
                abPermission="w"
                :disabled="permission.qualifications!=='w'"
                :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
              ></ab-upload>
            </td>
            <th>
              <span class>{{ $t('label.Supplier.Strength.MajorClient') }}</span>
            </th>
            <td colspan="2">
              <Form-item prop="mainCustomer">
                <Input
                  :disabled="permission.mainCustomer!=='w'"
                  autosize
                  type="textarea"
                  v-model="formdata.mainCustomer"
                />
              </Form-item>
            </td>
          </tr>

          <!-- 财务信息 -->
          <template v-if="formdata.isNda =='1'">
            <tr>
              <th :rowspan="rowspan">
                <span class>{{ $t('label.Supplier.FinanceA') }}</span>
              </th>
              <td colspan="6" style="height:43px;">
                <!-- 注：如贵司于TMEC会发生金钱交易的情况下，请务必认真填写一些内容 -->
                <div class="tipscontent" style="text-align:center;">
                  <span class="circleicon">
                    <Icon type="ios-information-circle" />
                  </span>
                  <span>{{$t('label.Supplier.Finance.Comment')}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                <span class="requiredIitm">{{ $t('lable.InquiryInvitationApply.corporateName')}}</span>
              </th>
              <td style="height:43px;border-right:none;" colspan="2">
                <Form-item prop="supplierPayName">
                  <Input
                    :disabled="permission.supplierPayName!=='w'"
                    type="text"
                    v-model="formdata.supplierPayName"
                  />
                </Form-item>
              </td>
              <td colspan="3">
                <div class="tipscontent">
                  <span class="circleicon">
                    <Icon type="ios-information-circle" />
                  </span>
                  <span>{{$t('label.SupplierApply.NameHint')}}</span>
                </div>
              </td>
            </tr>



            <!-- <tr v-if="formdata.isNda =='1'">
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.BankName') }}</span>
              </th>
              <td>
                <Form-item prop="bankName">
                  <Input
                    :disabled="permission.bankName!=='w'"
                    type="text"
                    v-model="formdata.bankName"
                  />
                </Form-item>
              </td>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.BankAccount') }}</span>
              </th>
              <td>
                <Form-item prop="accountNumber">
                  <Input
                    :disabled="permission.accountNumber!=='w'"
                    type="text"
                    v-model="formdata.accountNumber"
                  />
                </Form-item>
              </td>
            </tr>
            <tr>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.bankDomicils') }}</span>
              </th>
              <td>
                <Form-item prop="bankDomicileProvince">
                  <Input
                    :disabled="permission.bankDomicileProvince!=='w'"
                    type="text"
                    v-model="formdata.bankDomicileProvince"
                  />
                </Form-item>
              </td>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.bankDomicileCitys') }}</span>
              </th>
              <td>
                <Form-item prop="bankDomicileCity">
                  <Input
                    :disabled="permission.bankDomicileCity!=='w'"
                    type="text"
                    v-model="formdata.bankDomicileCity"
                  />
                </Form-item>
              </td>
            </tr> -->
                <tr  v-for="(item, index) in bankInformation.items"
                  :key="index" :v-if="formdata.isNda =='1'">
                  <th>
                      <Button type="primary"  @click="addInformation()" v-if="index==0" disabled><Icon type="md-add" /></Button>
                      <Button type="error"  @click="removeInformation(index)" v-if="index>0" disabled><Icon type="md-trash" /></Button>
                      <span class="requiredIitm">{{ $t('label.Supplier.Finance.BankName') }}</span>
                  </th>
                  <td style="width:18%;">
                    <Form-item prop="bankNames">
                      <Input :disabled="isDisabled" type="text" v-model="item.bankNames" />
                    </Form-item>
                  </td>
                  <th>
                    <span class="requiredIitm">{{ $t('label.Supplier.Finance.BankAccount') }}</span>
                  </th>
                  <td>
                    <Form-item prop="accountNumbers">
                      <Input :disabled="isDisabled" type="text" v-model="item.accountNumbers" />
                    </Form-item>
                  </td>
                  <th>
                    <span class="requiredIitm">{{ $t('label.Supplier.Finance.bankDomicils') }}</span>
                  </th>
                  <td>
                    <div class="cityitem" style="padding-left:5px;">
                      <Form-item prop="bankDomicileProvinces">
                        <Input
                          :disabled="isDisabled"
                          type="text"
                          v-model="item.bankDomicileProvincs"
                        />
                      </Form-item>
                    </div>
                    <div class="cityitem" style="padding-left:5px;">
                      <Form-item prop="bankDomicileCitys">
                        <Input
                          :disabled="isDisabled"
                          type="text"
                          v-model="item.bankDomicileCitys"
                        />
                      </Form-item>
                    </div>
                  </td>
                </tr>


            <tr>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.financeContact') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="financeContact">
                  <Input
                    :disabled="permission.financeContact!=='w'"
                    type="text"
                    v-model="formdata.financeContact"
                  />
                </Form-item>
              </td>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.financeTelephone') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="financeTelephone">
                  <Input
                    :disabled="permission.financeTelephone!=='w'"
                    type="text"
                    v-model="formdata.financeTelephone"
                  />
                </Form-item>
              </td>
            </tr>
            <tr>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.financeAddress') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="financeAddress">
                  <Input
                    :disabled="permission.financeAddress!=='w'"
                    type="text"
                    v-model="formdata.financeAddress"
                  />
                </Form-item>
              </td>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.financeEmail') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="financeEmail">
                  <Input
                    :disabled="permission.financeEmail!=='w'"
                    type="text"
                    v-model="formdata.financeEmail"
                  />
                </Form-item>
              </td>
            </tr>

            <tr>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.AdvancePayment10Wan') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="depositFlg" style="display:inline-block;">
                  <div style="display:flex;align-items:center;">
                    <RadioGroup v-model="formdata.depositFlg">
                      <Radio
                        :disabled="permission.depositFlg!=='w'"
                        label="0"
                      >{{ $t('label.Supplier.Finance.AdvancePaymentYes') }}</Radio>
                      <Radio
                        :disabled="permission.depositFlg!=='w'"
                        label="1"
                      >{{ $t('label.Supplier.Finance.AdvancePaymentNo') }}</Radio>
                    </RadioGroup>
                  </div>
                </Form-item>
              </td>
              <td rowspan="2" colspan="3">
                <div style="display:flex;align-items:center;">
                    <ab-upload
                      v-if="formdata.depositFlg === '0' && formdata.blockTradeFlg === '0' && formdata.specialFlg === '1'"
                      v-model="formdata.depositFile"
                      abPermission="w"
                      :disabled="permission.depositFlg!=='w'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                    <div class="tipscontent" style="text-align:center;width:auto;margin-left:10px;" v-if="formdata.depositFlg === '0' && formdata.blockTradeFlg === '0' && formdata.specialFlg === '1'">
                      <span class="circleicon">
                        <Icon type="ios-information-circle" />
                      </span>
                      <span>{{$t('label.SupplierApply.FileHint')}}</span>
                    </div>
                </div>
               </td>   
            </tr>
            
            <!-- 新追加 10万元以上交易 模块 -->
            <tr>
              <th>
                <span class="requiredIitm">{{ $t('label.Supplier.Finance.Transaction10Wan') }}</span>
              </th>
              <td colspan="2">
                <Form-item prop="blockTradeFlg" style="display:inline-block;">
                  <div style="display:flex;align-items:center;">
                    <RadioGroup v-model="formdata.blockTradeFlg">
                      <Radio
                        :disabled="permission.blockTradeFlg!=='w'"
                        label="0"
                      >{{ $t('label.Supplier.Finance.AdvancePaymentYes') }}</Radio>
                      <Radio
                        :disabled="permission.blockTradeFlg!=='w'"
                        label="1"
                      >{{ $t('label.Supplier.Finance.AdvancePaymentNo') }}</Radio>
                    </RadioGroup>
                  </div>
                </Form-item>
              </td>
            </tr>

            <!-- <tr>
              <th>
                <span class="requiredIitm">{{ $t('GYS-bg') }}</span>
              </th>
              <th>
                <span class="requiredIitm">{{ $t('label.SupplierModify.ChangeReason') }}</span>
              </th>
              <td colspan="1">
                <Form-item prop="updateReason">
                  <Input
                    :disabled="permission.supplierNameCn!=='w'"
                    type="text"
                    v-model="formdata.updateReason"
                    width="100%"
                  />
                </Form-item>
              </td>
              <td colspan="2">
                <div>
                  <ab-upload v-model="formdata.updateFile" abPermission="w" :disabled="permission.supplierNameCn!=='w'"></ab-upload>
                </div>
              </td>
            </tr>-->
          </template>
        </table>
      </Form>
    </Card>
  </div>
</template>
<script>
import { Input } from "view-design";
import util from "@/libs/util";
export default {
  data: function() {
    return {
      rowspan: 6,
      currencyList: [
        "RMB",
        "SGD",
        "PHP",
        "MOP",
        "RUB",
        "IDR",
        "KRW",
        "MYR",
        "IDR",
        "VND",
        "DKK",
        "JPY",
        "SEK",
        "USD",
        "AUD",
        "TWD",
        "THB",
        "EUR",
        "GBP",
        "HKD"
      ],
      formdata: {},
      bankInformation: {
        items: []
      },
      permission: {},
      detail: false,
      // 控制是否禁用
      supplierName: true,
      isDisabled: true,
      time: "",

      listProperties: [
        {
          label: $t("label.Supplier.Basic.Foreign"),
          value: "0"
        },
        {
          label: $t("label.Supplier.Basic.ventures"),
          value: "1"
        },
        {
          label: $t("label.Supplier.Basic.domestic"),
          value: "2"
        }
      ],
      rules: {
        //请输入币种
        currency: [
          {
            required: true,
            message: util.getmsg(this, "lable.InquiryInvitationApply.currency"),
            trigger: "change"
          }
        ],
        supplierPayName: [
          // 请输入公司名称
          {
            required: true,
            message: util.getmsg(
              this,
              "lable.InquiryInvitationApply.corporateName"
            ),
            trigger: "change"
          }
        ],
        businessLicense: [
          // 请输入营业执照
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.BusinessLicense"),
            trigger: "change"
          }
        ],
        updateReason: [
          // 请输入变更理由
          {
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.ChangeReason"),
            trigger: "change"
          }
        ],
        applId: [
          // 请输入邀请人ID
          {
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.InviterID"),
            trigger: "change"
          }
        ],
        applyDepartment: [
          // 请输入申请人部门
          {
            required: true,
            message: util.getmsg(this, "label.SupplierAddApply.ApplyDept"),
            trigger: "change"
          }
        ],
        investedPercenVal4: [
          {
            validator: (rule, value, callback) => {
              if (this.formdata.investedPercenTxt4 && !value) {
                // 请输入投资方4占比
                callback(
                  util.getmsg(this, "label.Supplier.ProportionOfInvestors4")
                );
              } else if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenVal3: [
          {
            validator: (rule, value, callback) => {
              //请输入投资方3占比
              if (this.formdata.investedPercenTxt3 && !value) {
                callback(
                  util.getmsg(this, "label.Supplier.ProportionOfInvestors3")
                );
              } else if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenVal2: [
          {
            validator: (rule, value, callback) => {
              // 请输入投资方2占比
              if (this.formdata.investedPercenTxt2 && !value) {
                callback(
                  util.getmsg(this, "label.Supplier.ProportionOfInvestors2")
                );
              } else if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenVal1: [
          {
            validator: (rule, value, callback) => {
              // 请输入投资方1占比
              if (this.formdata.investedPercenTxt1 && !value) {
                callback(
                  util.getmsg(this, "label.Supplier.ProportionOfInvestors1")
                );
              } else if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenTxt1: [
          {
            validator: (rule, value, callback) => {
              // 请输入投资方1
              if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else if (!value && this.formdata.investedPercenVal1) {
                callback(util.getmsg(this, "label.Supplier.Investor1"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenTxt2: [
          {
            //请输入投资方2
            validator: (rule, value, callback) => {
              if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else if (!value && this.formdata.investedPercenVal2) {
                callback(util.getmsg(this, "label.Supplier.Investor2"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenTxt3: [
          {
            // 请输入投资方3
            validator: (rule, value, callback) => {
              if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else if (!value && this.formdata.investedPercenVal3) {
                callback(util.getmsg(this, "label.Supplier.Investor3"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        investedPercenTxt4: [
          {
            validator: (rule, value, callback) => {
              // 请输入投资方4
              if (!this.validate_g) {
                callback(util.getmsg(this, "label.Supplier.investment"));
              } else if (!value && this.formdata.investedPercenVal4) {
                callback(util.getmsg(this, "label.Supplier.Investor4"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        qualifications: [
          //请输入行业相关资质
          {
            required: false,
            message: util.getmsg(
              this,
              "label.Supplier.Strength.Qualifications"
            ),
            trigger: "change"
          }
        ],
        province: [
          // 请输入省
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Strength.province"),
            trigger: "change"
          }
        ],
        contact: [
          // 请输入联系人
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.SupplierContact"),
            trigger: "change"
          }
        ],
        supplierNameCn: [
          // 请输入公司中文名
          {
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Basic.corporateNameChinese"
            ),
            trigger: "change"
          }
        ],
        isNda: [
          // 请输入保密协议
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.IsNda"),
            trigger: "change"
          }
        ],
        internalFlg: [
          // 供应商国别
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.SupplierCountry"),
            trigger: "change"
          }
        ],
        depositFlg: [
          {
            // 请输入10万以上预付款
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Finance.AdvancePayment10Wan"
            ),
            trigger: "change"
          }
        ],
        blockTradeFlg: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Finance.Transaction10Wan"
            ),
            trigger: "change"
          }
        ],
        riskInvestigation: [
          {
            // 企业风险情况调查不能为空
            required: true,
            message: util.getmsg(this, "label.SupplierApply.Risk"),
            trigger: "change"
          }
        ],
        mailAddress: [
          // 请输入邮件
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  util.getmsg(this, "label.Supplier.Basic.SupplierEmail")
                );
              } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(
                  $t("label.Supplier.Basic.SupplierEmail") + $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ],
        timeOfEstablishment: [
          {
            // 请输入成立时间
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Basic.SupplierEstablishDate"
            ),
            trigger: "change"
          }
        ],
        // 请输入电话
        telNo: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                // 请输入电话
                callback(
                  util.getmsg(this, "label.Supplier.Basic.SupplierPhone")
                );
              } else if (!/^[\d\-]+$/.test(value)) {
                //电话不正确
                callback(
                  $t("label.Supplier.Basic.SupplierPhone") + $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ],
        businessLine: [
          // 请输入经营范围
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.BizScope"),
            trigger: "change"
          }
        ],
        updateFile: [
          {
            // 请输入变更申请时证明材料附件
            required: true,
            message:
              $t("ERR-000") +
              $t("label.SupplierModify.ChangeReason") +
              $t("label.SupplierAdd.Accessory"),
            trigger: "change"
          }
        ],
        depositFile: [
          {
            // 10万以上预付款附件不能为空
            required: true,
            message:
              $t("ERR-000") +
              $t("label.Supplier.Finance.AdvancePayment10Wan") +
              $t("label.SupplierAdd.Accessory"),
            trigger: "change"
          }
        ],
        enterpriseProperties: [
          // 企业形式不能为空
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.SupplierProperty"),
            trigger: "change"
          }
        ],
        status: [
          // 供应商状态不能为空
          {
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.SupplierStatus"),
            trigger: "change"
          }
        ],
        supplierId: [
          // 请输入供应商ID
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.SupplierId"),
            trigger: "change"
          }
        ],
        isIran: [
          {
            // 是否伊朗相关企业不能为空
            required: true,
            message: util.getmsg(this, ""),
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: $t("label.Supplier.Basic.SupplierCity"),
            trigger: "change"
          }
        ],
        supplierNameJp: [
          // 请输入公司日文名
          {
            required: false,
            message: util.getmsg(this, "label.Supplier.Basic.English"),
            trigger: "change"
          }
        ],
        bankName: [
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Finance.BankName"),
            trigger: "change"
          }
        ],
        content: [
          {
            // 请输入购买/委托内容
            required: true,
            message: util.getmsg(this, "label.SupplierApply.InvitationReason"),
            trigger: "change"
          }
        ],
        legalRepresentative: [
          // 请输入法人代表
          {
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Basic.SupplierLealperson"
            ),
            trigger: "change"
          }
        ],
        registeredCapital: [
          {
            // 请输入注册资金
            type: "number",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  value === 0
                    ? util.getmsg(
                        this,
                        "label.Supplier.Basic.SupplierRegisterMoney"
                      )
                    : util.getmsg(
                        this,
                        "label.Supplier.Basic.SupplierRegisterMoney"
                      )
                );
              } else {
                callback();
              }
            }
          }
        ],
        applName: [
          {
            // 请输入邀请人/申请人
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.Inviter"),
            trigger: "change"
          }
        ],
        opeType: [
          // 请输入申请区分
          {
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.ApplyToDistinguish"),
            trigger: "change"
          }
        ],
        supplierNameEn: [
          // 请输入公司英文名
          {
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Basic.corporateNameEnglish"
            ),
            trigger: "change"
          }
        ],
        invitationDate: [
          {
            //邀请日期/申请日期不能为空
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.ApplyDate"),
            trigger: "change"
          }
        ],
        isUsSanctions: [
          {
            // 是否美国制裁企业不能为空
            required: true,
            message: util.getmsg(this, "label.SupplierAdd.UScompanies"),
            trigger: "change"
          }
        ],
        supplierName: [
          // 请输入供应商名称
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.SupplierName")
          }
        ],
        address: [
          // 请输入详情地址
          {
            required: true,
            message: util.getmsg(
              this,
              "label.Supplier.Basic.SupplierAddressDetail"
            ),
            trigger: "change"
          }
        ],
        specialFlg: [
          // 请输入特殊企业
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Basic.SpecialBiz")
          }
        ],
        accountNumber: [
          // 账号格式不正确
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  util.getmsg(this, "label.Supplier.Finance.BankAccount")
                );
              } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(
                  $t("label.Supplier.Finance.BankAccount") + $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ],
        faxNo: [
          {
            // 传真格式不正确,请输入传真
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (!/^[\d\-]+$/.test(value)) {
                callback($t("label.Supplier.Basic.SupplierFax") + $t("ERR-00"));
              } else {
                callback();
              }
            }
          }
        ],
        mainCustomer: [
          // 请输入主要客户
          {
            required: false,
            message: util.getmsg(this, "label.Supplier.Strength.MajorClient"),
            trigger: "change"
          }
        ],
        bankDomicileProvince: [
          // 请输入银行住址（省）
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Strength.bankDomicileProvince"),
            trigger: "change"
          }
        ],
        bankDomicileCity: [
          // 请输入银行住址（市）
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Strength.bankDomicileCity"),
            trigger: "change"
          }
        ],
        financeContact: [
          // 请输入联系人（财务）
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Strength.FinanceContact"),
            trigger: "change"
          }
        ],
        financeTelephone: [
          // 请输入电话（财务）
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                // 请输入电话
                callback(
                  util.getmsg(this, "label.Supplier.Strength.financeTelephone")
                );
              } else if (!/^[\d\-]+$/.test(value)) {
                //电话不正确
                callback(
                  $t("label.Supplier.Strength.financeTelephone") + $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ],
        financeAddress: [
          // 请输入地址（财务）
          {
            required: true,
            message: util.getmsg(this, "label.Supplier.Strength.FinanceAddress"),
            trigger: "change"
          }
        ], 
        financeEmail: [
          // 请输入邮箱（财务）
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  util.getmsg(this, "label.Supplier.Strength.financeEmail")
                );
              } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(
                  $t("label.Supplier.Strength.financeEmail") + $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ]      
      }
    };
  },
  props: {
    parent: {
      // 默认数据
      supplierNameCn: "",
      supplierNameEn: "",
      supplierNameJp: "",
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.formdata = this.parent.data.gysywb;
    this.bankInformation.items = this.parent.data.gysywb.BANKINFORMATIONList;
    const data = this.bankInformation.items;
          data.forEach(item => {
            this.rowspan++;
    });
    this.permission = this.parent.permission.gysywb.TSUPPLIERAPPLY;
    //申请节点
    if (!this.formdata.registeredCapital) {
      this.$set(this.formdata, "registeredCapital", null);
    }
    if (!this.formdata.investedPercenVal1) {
      this.$set(this.formdata, "investedPercenVal1", null);
    }
    if (!this.formdata.investedPercenVal2) {
      this.$set(this.formdata, "investedPercenVal2", null);
    }
    if (!this.formdata.investedPercenVal3) {
      this.$set(this.formdata, "investedPercenVal3", null);
    }
    if (!this.formdata.investedPercenVal4) {
      this.$set(this.formdata, "investedPercenVal4", null);
    }
  },
  computed: {
    //行业相关资质 qualifications
    validate_f() {
      return this.formdata.qualifications &&
        this.formdata.qualifications.length > 2 &&
        this.formdata.isNda === "1"
        ? true
        : this.formdata.isNda === "0"
        ? true
        : false;
    },
    //营业执照不可以为空校验
    validate_c() {
      return this.formdata.businessLicense &&
        this.formdata.businessLicense.length > 2
        ? true
        : false;
    },
    //选择10万元以上为可时 附件必须上传
    validate_d() {
      var flg_a = false;
      if (this.formdata.isNda === "1") {
        if (
          this.formdata.depositFlg === "0" &&
          this.formdata.blockTradeFlg === "0" &&
          this.formdata.specialFlg === "1" &&
          this.formdata.depositFile &&
          this.formdata.depositFile.length > 2
        ) {
          flg_a = true;
        }
        if (this.formdata.depositFlg === "1" ||
          this.formdata.blockTradeFlg === "1" ||
          this.formdata.specialFlg === "0") {
          flg_a = true;
        }
        if (!this.formdata.depositFlg || !this.formdata.blockTradeFlg || !this.formdata.specialFlg) {
          flg_a = true;
        }
      } else {
        flg_a = true;
      }

      return flg_a;
    },
    //投资占比及投资方是否一个未填写
    validate_g() {
      return this.formdata.investedPercenVal1 ||
        (this.formdata.investedPercenVal2 &&
          this.formdata.investedPercenVal3) ||
        this.formdata.investedPercenVal4 ||
        this.formdata.investedPercenTxt1 ||
        this.formdata.investedPercenTxt2 ||
        this.formdata.investedPercenTxt3 ||
        this.formdata.investedPercenTxt4
        ? true
        : false;
    }
  },
  methods: {
    // 表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      var that = this;
      var check = async function getVaild() {
        var validateflg = false;
        var validate_a = false;
        var validate_e = await that.abHttpUtil
          .post(
            "/supplierAddApply/supplierNamecheck?supplierNameCn=" +
              that.formdata.supplierNameCn +
              "&supplierNameEn=" +
              that.formdata.supplierNameEn +
              "&supplierNameJp=" +
              that.formdata.supplierNameJp,
            {}
          )
          .then(res => {
            return res === 0 ? true : false;
          });
        //投资占比不能大于100'
        if (that.formdata.specialFlg === "1" && that.formdata.isNda === "1") {
          var number_a = that.formdata.investedPercenVal1
            ? that.formdata.investedPercenVal1
            : 0;
          var number_b = that.formdata.investedPercenVal2
            ? that.formdata.investedPercenVal2
            : 0;
          var number_c = that.formdata.investedPercenVal3
            ? that.formdata.investedPercenVal3
            : 0;
          var number_d = that.formdata.investedPercenVal4
            ? that.formdata.investedPercenVal4
            : 0;
          validate_a =
            number_a + number_b + number_c + number_d > 100 ? false : true;
        } else {
          validate_a = true;
        }
        // 校验主体
        that.$refs.formdata.validate(valid => {
          if (
            valid &&
            validate_a &&
            that.validate_c &&
            that.validate_d &&
            validate_e && that.validateList().flg
          ) {
            validateflg = true;
          } else {
            var list = [];
            if (
              that.formdata.specialFlg === "1" &&
              that.formdata.isNda === "1" &&
              !validate_a
            ) {
              //投资占比总和不能超过100
              list.push($t("ERR.SupplierAdd.004"));
            }
            if (!that.validate_c) {
              list.push(
                util.getmsg(that, "label.Supplier.Basic.BusinessLicense")
              );
            }
            if (!that.validate_d) {
              list.push($t("ERR.Supplier.001"));
            }
            if (!validate_e) {
              list.push($t("ERR.SupplierAdd.002"));
            }
            if(!that.validateList().flg){
              list = list.concat(that.validateList().list)
            }
            that.errmsg(list);
          }
        });
        return validateflg;
      };
      return check();
    },
    // 表单重置
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    //国别切换
    nameTextChange(e) {
      this.$set(
        this.formdata,
        "supplierPayName",
        e === "1" && this.formdata.supplierNameEn
          ? this.formdata.supplierNameEn
          : e === "0" && this.formdata.supplierNameCn
          ? this.formdata.supplierNameCn
          : ""
      );
      this.$set(this.formdata, "city", "");
      this.$set(this.formdata, "province", "");
    },
    changeTextName() {
      this.$set(
        this.formdata,
        "supplierPayName",
        this.formdata.internalFlg === "1" && this.formdata.supplierNameEn
          ? this.formdata.supplierNameEn
          : this.formdata.internalFlg === "0" && this.formdata.supplierNameCn
          ? this.formdata.supplierNameCn
          : ""
      );
    },
    //校验
    errmsg(custom) {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        if (custom.length > 0) {
          errMsg = errMsg.concat(custom);
        }
        errMsg.forEach(val => {
          this.$Message.error({ content: val, duration: 5 });
        });
      });
    },
    //是否特殊企业切换
    specialFlgChange() {
      this.$set(this.formdata, "investedPercenTxt1", null);
      this.$set(this.formdata, "investedPercenTxt2", null);
      this.$set(this.formdata, "investedPercenTxt3", null);
      this.$set(this.formdata, "investedPercenTxt4", null);
      this.$set(this.formdata, "investedPercenVal1", null);
      this.$set(this.formdata, "investedPercenVal2", null);
      this.$set(this.formdata, "investedPercenVal3", null);
      this.$set(this.formdata, "investedPercenVal4", null);
      this.$set(this.formdata, "enterpriseProperties", null);
    },
    //明细校验
    validateList() {
      var list = []
      var list1 = []
      this.bankInformation.items.forEach((val) => {
        // bankNames //银行名
        // accountNumbers //账号
        // bankDomicileProvincs //银行住所 省
        // bankDomicileCitys //银行住所 市
        if (!val.bankNames || val.bankNames === "") {
            list.push(util.getmsg(this, "银行账号"))
        }
        if (!val.accountNumbers || val.accountNumbers === "") {
            list.push(util.getmsg(this, "银行账号"))
        }
        if (!val.bankDomicileProvincs || val.bankDomicileProvincs === "") {
            list.push(util.getmsg(this, "银行住所 省"))
        }
        if (!val.bankDomicileCitys || val.bankDomicileCitys === "") {
            list.push(util.getmsg(this, "银行住所 市"))
        }
        if (!/^[\d\-]+$/.test(val.accountNumbers)){
            list.push("银行账号不正确")
        }
      });
      list.forEach(val=>{
        if(list1.indexOf(val)===-1){
          list1.push(val)
        }
      })
      return {
        flg:list.length===0 ? true : false,
        list:list1
      }
    },
  }
};
</script>
<style scoped>
.tipbox .ivu-tooltip-inner {
  max-width: auto;
}
.typecontent {
  display: flex;
  align-items: center;
}
.typecontent ul {
  width: 600px;
}
.typecontent ul > li {
  display: flex;
  align-items: center;
  margin: 5px;
}
.typecontent ul > li > .text {
  margin-left: 15px;
  margin-right: 5px;
}
.cityitem {
  display: inline-block;
  width: 48%;
}
.content_box {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
}
.contentleft {
  width: 60%;
}
.contentright {
  height: 100%;
  width: 40%;
}
.contentright > div {
  border-bottom: 1px solid #dcdee2;
  border-left: 1px solid #dcdee2;
  height: 33.33333%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.contentright > div:last-child {
  border-bottom: none;
}
.circleicon {
  color: #2d8cf0;
  font-size: 16px;
  margin-right: 5px;
}
.tipscontent {
  text-align: left;
  width: calc(100% - 16px);
  display: inline-block;
  background: #f5faff;
  padding: 0px 15px;
  border-radius: 5px;
  line-height: 30px;
  border: 1px solid #abdcff ;
}
.tipbox .ivu-tooltip-inner {
  max-width: auto;
}
</style>
